module.exports = __webpack_public_path__ + "static/media/26UNRWA1.e40e551a.jpg";